import { useTranslation } from 'react-i18next';

import PageLayout from '../components/PageLayout';
import AccountCard from '../components/AccountCard';
import AdminBrandingForm from '../components/AdminBrandingForm';
import AdminSidebarForm from '../components/AdminSidebarForm';
import PageHeader from '../components/ui/PageHeader';
import PageBody from '../components/ui/PageBody';
import PageMain from '../components/ui/PageMain';

/**
 * How the platform looks: its branding and its sidebar.
 *
 * Both used to sit at the top of the admin panel, which meant changing a logo
 * required the right to administer accounts, groups and departments. They are
 * one concern of their own, behind one right - `interface.manage`.
 */
function InterfacePage() {
  const { t } = useTranslation();

  return (
    <PageLayout
      extraSidebarItems={[
        {
          to: '/interface',
          label: t('interfacePage.pageTitle'),
          icon: 'fa-solid fa-palette',
        },
      ]}
    >
      <PageMain>
        <PageHeader
          eyebrow={t('interfacePage.eyebrow')}
          title={t('interfacePage.pageTitle')}
          titleId="interface-page-title"
          description={t('interfacePage.pageDescription')}
        />

        <PageBody
          className="account-page"
          aria-labelledby="interface-page-title"
        >
          <div className="account-settings-column admin-settings-column">
            <AccountCard
              titleId="interface-branding-title"
              isFirst
              title={t('adminPanel.brandingSectionTitle')}
              description={t('adminPanel.brandingSectionDescription')}
              icon="fa-solid fa-palette"
            >
              <AdminBrandingForm />
            </AccountCard>

            <AccountCard
              titleId="interface-sidebar-title"
              title={t('adminPanel.SidebarTitle')}
              description={t('adminPanel.SidebarDescription')}
              icon="fa-solid fa-sliders"
            >
              <AdminSidebarForm />
            </AccountCard>
          </div>
        </PageBody>
      </PageMain>
    </PageLayout>
  );
}

export default InterfacePage;
